import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { IApiEntitySmpAgTemplate } from "@smp/api";
import { REACT_APP__BASE_PATH } from "@smp/utils";
import { useMemo } from "react";

import { getLocationOrigin } from "@/utils";

export type ITemplateMeta = {
  name: string;
  title: string;
  desc: string;
  author: string | undefined;
  size: string[] | undefined;
  image: string;
  keywords: string | undefined;
  canonical: string;
};

export const useTemplateMeta = (
  template: IApiEntitySmpAgTemplate | undefined,
): ITemplateMeta | undefined => {
  const { i18n } = useLingui();

  const templateName =
    template?.template_name?.trim() || t`Template` + " " + template?.id;

  const origin = useMemo(getLocationOrigin, []);

  return useMemo(
    () =>
      template
        ? {
            name: templateName,
            title: [
              templateName,
              t`template for social networks, messengers and advertising creatives`,
              t`Canvas` + " SMMplanner",
            ].join(" - "),
            desc: (() => {
              const desc = template.description[i18n.locale];

              if (!desc) {
                return t`Template on the theme «${templateName}», which can be easily edited to your requirements in the graphical online editor of the canvas from the SMMPlanner service.`;
              }

              return desc.split("\n")[0];
            })(),
            author: template.tags
              .find((tag) => tag.startsWith("author_"))
              ?.replace(/^author_/, ""),
            size: template.tags
              .find((tag) => tag.startsWith("size_"))
              ?.replace(/^size_/, "")
              .split("x"),
            image: template.preview_url,
            keywords: template.keywords?.[i18n.locale],
            canonical: `${origin}${REACT_APP__BASE_PATH}/templates/${template.id}`,
          }
        : undefined,
    [i18n.locale, origin, template, templateName],
  );
};
